<template>

    <span class="grid-content" @click="fullScreenHandler" v-show="!isFull">
        <el-button size="small">
            <i class="el-icon-full-screen"></i>
            视图全屏
        </el-button>
    </span>

</template>

<script>

    import {addScreenListener, fullScreenOper, isFullscreen} from '@/util/common/fullScreen'

    export default {
        name: "fullScreenBtn",

        props: {
            hideElIds: {        //全屏后需要隐藏的组件
                type: Array,
            }
        },

        data() {
            return {
                isFull: false,  //默认为未全屏（false非全屏，true全屏）
            }
        },

        methods: {
            fullScreenHandler() {
                fullScreenOper(document.getElementById('globalBody'));  //全屏body部分
                this.isFull = true;
            },

            /**
             * 全屏、非全屏切换后做些额外的操作：去除header、footer、以及page的样式
             */
            fullScreenChange() {
                let isFull = isFullscreen();
                if (!isFull) {
                    this.isFull = false;
                    console.log('非全屏');
                    document.getElementById("side-menu").style.display = "block";
                    $(document.getElementById("globalPage")).addClass("page");
                    document.getElementById("globalFooter").style.display = "block";

                    this.hideOrShowOper('show', this.hideElIds);
                } else {
                    console.log('全屏');
                    document.getElementById("side-menu").style.display = "none";
                    $(document.getElementById("globalPage")).removeClass("page");
                    document.getElementById("globalFooter").style.display = "none";

                    this.hideOrShowOper('hide', this.hideElIds);
                }
            },

            /**
             * 对非header和footer部分做隐藏、展示操作，elIds为父组件传递过来的组件id
             * @param flag
             * @param elIds
             */
            hideOrShowOper(flag, elIds) {
                elIds.forEach(e => {
                    if (flag == 'show') {
                        document.getElementById(e).style.display = "block";
                    } else {
                        document.getElementById(e).style.display = "none";
                    }
                });
            },

        },

        mounted() {
            addScreenListener(this.fullScreenChange);
        },

    }
</script>

<style scoped>

</style>